import { useEffect } from 'react';
import {
  internalCampaignProductAnalyticsList,
  fireEnhancedEcomm,
  internalPromotionFormattedProducts,
} from '@tcp/core/src/utils/index';
import pushEventToAdobeAnalytics, {
  getPLPPageName,
} from '../../../../../../adobeAnalytics/adobe.utils';
import {
  getAnalyticsFormatedProductsEE,
  getHorizontalCategoryPageTrackData,
  getIcidValue,
  getIcidWithPromoFilterSlot,
  getSearchAnalyticsData,
} from '../../../CategoryListingPage/container/analyticsHelper';

function sendAdobePageViewEvent(pageDataAdobe, User, APIConfig, session) {
  return new Promise((resolve) => {
    pushEventToAdobeAnalytics('page_view', { pageData: pageDataAdobe, User, APIConfig, session });
    resolve();
  });
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function useHlpAnalytics(props, aplp) {
  const {
    router,
    trackPageLoad,
    currency,
    breadCrumbs,
    isNewNavigationImagesEnabled,
    storeId,
    defaultStoreId,
    currentCid,
    horizontalPlpProducts,
    isTopRatedBackAbEnabled,
    isBestSellerBackAbEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    currentNavIds,
    cid,
    isInitialCall,
    User,
    APIConfig,
    session,
    promotionsData,
  } = props;
  if (cid !== currentCid) return;

  useEffect(() => {
    if (isInitialCall) {
      let store = storeId;
      if (!store) {
        store = defaultStoreId;
      }
      // varable name paginatedProducts used because the utility "getAnalyticsFormatedProductsEE" used is common for HLP and new PLP
      const { asPath } = router;
      const paginatedProducts = [];
      let length = 0;
      const categoryData = horizontalPlpProducts[`${currentNavIds[currentNavIds.length - 1]}`];
      categoryData?.forEach((data) => {
        const productsDataSet = data?.products;
        if (length <= 20 && productsDataSet) {
          productsDataSet?.forEach((productsData) => {
            paginatedProducts[length] = productsData;
            length += 1;
          });
        }
      });
      const promotionalProducts = internalCampaignProductAnalyticsList();
      const productsFormattedEE = getAnalyticsFormatedProductsEE({
        paginatedProducts,
        breadCrumbs,
        currency,
        isTopRatedBackAbEnabled,
        isBestSellerBackAbEnabled,
        isHideOriginalPriceAndMarchantTagEnabled,
        promotionsData,
      });
      const icid = getIcidValue(router && router.asPath);
      const viaPromoFilterIcid = getIcidWithPromoFilterSlot(router, breadCrumbs, 'hlp');
      let categoryListingPageTrackerData = getHorizontalCategoryPageTrackData(
        breadCrumbs,
        isNewNavigationImagesEnabled,
        router,
        icid,
        store,
        paginatedProducts,
        aplp
      );

      if (viaPromoFilterIcid) {
        categoryListingPageTrackerData.customEvents = ['event91', 'event81'];
        categoryListingPageTrackerData.internalCampaignId = viaPromoFilterIcid;
      }

      if (icid) {
        categoryListingPageTrackerData.customEvents = ['event91', 'event92', 'event81', 'event80'];
        categoryListingPageTrackerData.pageNavigationText = '';
        categoryListingPageTrackerData.departmentList = '';
        categoryListingPageTrackerData.pageSearchType = '';
        categoryListingPageTrackerData.internalCampaignId = icid;
      }
      const breadCrumbNames = breadCrumbs?.map((breadCrumb) =>
        breadCrumb.displayName.toLowerCase()
      );
      const pagetype = `browse-${aplp ? 'aplp' : 'hlp'}:${breadCrumbNames.join(':')}`;
      categoryListingPageTrackerData.pageName = pagetype;
      if (aplp) {
        categoryListingPageTrackerData.customEvents = ['event91', 'event82'];
      }
      categoryListingPageTrackerData = getSearchAnalyticsData(
        categoryListingPageTrackerData,
        asPath,
        productsFormattedEE,
        productsFormattedEE.length
      );
      trackPageLoad(categoryListingPageTrackerData);
      fireEnhancedEcomm({
        eventName: 'productimpression',
        productsObj: productsFormattedEE,
        eventType: 'impressions',
        pageName: categoryListingPageTrackerData.pageName || (aplp ? 'APLP' : 'HLP'),
        currCode: currency,
        eventLabel: 'Product impression',
      });
      const hplpPromotionalData = [];
      promotionalProducts?.forEach((item) => {
        const hasPlp = item?.split('plp_s');
        if (hasPlp?.length > 1) {
          hplpPromotionalData.push(`hplp_s${hasPlp?.[1]}`);
        } else {
          hplpPromotionalData.push(item);
        }
      });
      if (promotionalProducts) {
        fireEnhancedEcomm({
          eventName: 'internalcampaignimpression',
          productsObj: internalPromotionFormattedProducts(hplpPromotionalData),
          eventType: 'promoView',
          pageName: categoryListingPageTrackerData.pageName || (aplp ? 'APLP' : 'HLP'),
          currCode: currency,
        });
      }
      const pageName = getPLPPageName(breadCrumbs);
      const pageDataAdobe = {
        pageName,
        pageSection: breadCrumbs?.[1]?.displayName,
        pageSubSection: breadCrumbs?.[2]?.displayName,
        pageSubSection2: breadCrumbs?.[3]?.displayName,
        pageType: 'product listing page',
        pagination: asPath?.split('page=')?.[1],
      };
      sendAdobePageViewEvent(pageDataAdobe, User, APIConfig, session).then(() => {
        pushEventToAdobeAnalytics('product_impression', {
          productImpressions: productsFormattedEE,
          pageView: { pageData: pageDataAdobe, User, APIConfig, session },
        });
        pushEventToAdobeAnalytics(
          'promotional_banner_impression',
          internalPromotionFormattedProducts(hplpPromotionalData)
        );
      });
    }
  }, [currentCid, isInitialCall]);
}

export default useHlpAnalytics;
